import { render } from "./CollectionDetailedSearchMagazine.vue?vue&type=template&id=46215670&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMagazine.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMagazine.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMagazine.vue?vue&type=style&index=0&id=46215670&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46215670"]])

export default __exports__